import { ArrowBack, ArrowOutward } from "@mui/icons-material"
import { Box, Grid, Typography, useMediaQuery } from "@mui/material"
import { Link, useNavigate, useParams } from "react-router-dom"
import { UNKNOWNIcon } from "../../assets"
import { customPaletteColors } from "../../themes/common"
import { Button, tokenMapping } from "../commons"
import useGlobalStore from "../../stores/global"
import { useAccount } from "wagmi"

const TokenDetailsNav = () => {
  const isSmallerScreen = useMediaQuery((theme: any) => theme.breakpoints.down('sm'))
  const tokenDetailsPageHistoryCount = useGlobalStore(state => state.tokenDetailsPageHistoryCount)
  const setTokenDetailsPageHistoryCount = useGlobalStore(state => state.setTokenDetailsPageHistoryCount)
  const params = useParams()
  const navigation = useNavigate()
  const asset = params?.denom ?? ''
  const market = useGlobalStore(state => state.markets)?.find(market => market.asset.toUpperCase() === asset.toUpperCase())
  const assetInfo = tokenMapping[asset.toUpperCase()]
  const assetName = assetInfo?.name ?? asset
  const assetSymbol = market?.asset ?? asset
  const AssertIcon = assetInfo?.iconUrl ?? UNKNOWNIcon
  const account = useAccount()
  const blockExplorer = account?.chain?.blockExplorers?.default
  return (
    <Grid id="asset-nav" item container flexDirection={'row'} flexWrap={'nowrap'}
      justifyContent={'content'} alignItems={'center'} gap={3}>
      <Grid item>
        <Button color='secondary' onClick={() => {
          if (window.history?.length && window.history.length > 1) {
            navigation(tokenDetailsPageHistoryCount);
            setTokenDetailsPageHistoryCount(-1)
          } else {
            navigation('/', { replace: true });
            setTokenDetailsPageHistoryCount(-1)
          }
        }} sx={{ minWidth: '3rem' }}>
          <Grid container>
            <ArrowBack />
          </Grid>
        </Button>
      </Grid>
      <Grid item container gap={1} alignItems={'center'} flexDirection={'row'} flexWrap={'nowrap'}>
        <Grid item alignItems={'center'} sx={{ minWidth: { xs: '2.5rem', sm: '3rem' } }}>
          <AssertIcon style={{
            width: '100%', height: '100%'
            , marginTop: '0.2rem', aspectRatio: '1/1'
          }} />
        </Grid>
        <Grid container item gap={{ xs: 0, sm: 1 }} alignItems={'baseline'} flexDirection={{ sm: 'row', xs: 'column' }}>
          <Grid item>
            <Typography component={'span'} variant={isSmallerScreen ? "h5" : "h2"}>
              {assetSymbol}
            </Typography>
          </Grid>
          <Grid item sx={{ marginTop: { sm: '0rem', xs: '-0.5rem' } }}>
            <Typography component={'span'} variant={isSmallerScreen ? "xs" : "r"} sx={{
              color: 'text.secondary'
            }}>
              {assetName}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      {
        blockExplorer &&
        <Grid item>
          <Button color='secondary' sx={{ padding: { xs: '0.5rem 0rem', sm: '0.5rem 1rem' }, minWidth: '3rem' }}>
            <Grid container flexWrap={'nowrap'} alignItems={'center'}>
              <Typography component={'span'} variant="s" sx={{ display: { xs: 'none', sm: 'contents' } }}>
                <Box component={'span'}>
                  <Link to={`${blockExplorer.url}/address/${market?.contractAddress}`} target='_blank' style={{ color: customPaletteColors.contrastDarkText, textDecoration: 'none' }} >
                    {blockExplorer.name}
                  </Link>
                </Box>&nbsp;&nbsp;
              </Typography>
              <ArrowOutward fontSize='small' />
            </Grid>
          </Button>
        </Grid>
      }
    </Grid>
  )
}

export default TokenDetailsNav